export const RELATIONSHIP_WEIGHTS = {
  light: { width: 3, markerSize: 8, dasharray: "0" },
  standard: { width: 4.5, markerSize: 10, dasharray: "0" },
  strong: { width: 6, markerSize: 12, dasharray: "0" },
};

export const EDGE_STRENGTHS = {
  inherit: null,
  weak: { width: 3, markerSize: 8, dasharray: "8 7" },
  moderate: { width: 4.5, markerSize: 10, dasharray: "0" },
  strong: { width: 6, markerSize: 12, dasharray: "0" },
};

export function normalizeRelationshipWeight(value) {
  return Object.hasOwn(RELATIONSHIP_WEIGHTS, value) ? value : "standard";
}

export function normalizeEdgeStrength(value) {
  return Object.hasOwn(EDGE_STRENGTHS, value) ? value : "inherit";
}

export function resolveRelationshipPresentation(edgeStrength, mapWeight) {
  const normalizedStrength = normalizeEdgeStrength(edgeStrength);
  return EDGE_STRENGTHS[normalizedStrength]
    || RELATIONSHIP_WEIGHTS[normalizeRelationshipWeight(mapWeight)];
}
